export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_IS_READ_ONLY = 'SET_IS_READ_ONLY';
export const SET_IS_TELEHEALTH = 'SET_IS_TELEHEALTH';
export const GET_PATIENT_VISIT = 'GET_PATIENT_VISIT';
export const DELETE_PROBLEM = 'DELETE_PROBLEM';
export const ADD_PROBLEM = 'ADD_PROBLEM';
export const EDIT_PROBLEM = 'EDIT_PROBLEM';
export const TOGGLE_IS_VALID_PLAN = 'TOGGLE_IS_VALID_PLAN';
export const SET_SHOW_PROBLEM_FORM = 'SET_SHOW_PROBLEM_FORM';
export const SET_PROBLEM_EDIT = 'SET_PROBLEM_EDIT';
export const SET_WINDOW_PROPS = 'SET_WINDOW_PROPS';
export const EVENT_CHANGE = 'EVENT_CHANGE';
export const SUB_EVENT_CHANGE = 'SUB_EVENT_CHANGE';
export const REMOVE_ROW = 'REMOVE_ROW';
export const ADD_ROW = 'ADD_ROW';
export const UPDATE_STATUS_NOTE_OBJECT = 'UPDATE_STATUS_NOTE_OBJECT';
export const SUBMIT_FORM = 'SUBMIT_FORM';
export const SET_FORM = 'SET_FORM';
export const SET_MEDICATIONS_STATUS = 'SET_MEDICATIONS_STATUS';
export const SET_ALLERGIES_STATUS = 'SET_ALLERGIES_STATUS';
export const UPDATE_STATUS = 'UPDATE_STATUS';
export const TOGGLE_IN_EDITING = 'TOGGLE_IN_EDITING';
export const TOGGLE_IN_REVIEW = 'TOGGLE_IN_REVIEW';
export const DELETE_ENCOUNTER = 'DELETE_ENCOUNTER';
export const REOPEN_ENCOUNTER = 'REOPEN_ENCOUNTER';
export const REFRESH_ALLERGIES = 'REFRESH_ALLERGIES';
export const REFRESH_MEDICATIONS = 'REFRESH_MEDICATIONS';
export const BEGIN_REVIEW = 'BEGIN_REVIEW';
export const UNASSIGN_REVIEW = 'UNASSIGN_REVIEW';
export const RETURN_TO_REVIEW = 'RETURN_TO_REVIEW';
export const UPDATE_PATIENT_VISIT_DATA = 'UPDATE_PATIENT_VISIT_DATA';
export const PRE_FILL_HISTORY = 'PRE_FILL_HISTORY';
export const UPDATE_DIAGNOSIS_PLAN_OF_CARE = 'UPDATE_DIAGNOSIS_PLAN_OF_CARE';
